import React, { memo } from "react";
import { AppMessage } from "~/components/elements/AppMessage";
import {
  ButtonProps,
  LayoutProps,
  Modal,
  ModalBody,
  ModalBodyProps,
  ModalContent,
  ModalContentProps,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  useDisclosure,
} from "@chakra-ui/react";
import { UiBox, UiHStack } from "~/components/elements/index";
import { AiOutlineClose } from "react-icons/ai";
import { UiButton } from "./UiButton";
import { UiIcon } from "./UiIcon";

interface Props extends ModalProps {
  headerTitle?: React.ReactNode;
  submitText?: string;
  closeText?: string;
  loading?: boolean;
  loadingClose?: boolean;
  loadingContent?: boolean;
  isOpen: boolean;
  errors?: any;
  onClickSubmitBtn?: (e: React.FormEvent) => any;
  onClose: () => any;
  header?: React.ReactNode;
  actions?: React.ReactNode;
  hideSubmit?: boolean;
  hideClose?: boolean;
  contentMinW?: LayoutProps["minW"];
  contentMaxW?: LayoutProps["maxW"];
  children: React.ReactNode;
  disableSubmit?: boolean;
  modalBodyProps?: ModalBodyProps;
  rightCornerBtnProps?: ButtonProps;
  modalContentProps?: ModalContentProps;
  showFooter?: boolean;
  showRightConnerCloseButton?: boolean;
}

const confirmCloseQuestion = "Are you sure you wish to close without saving? This action cannot be undone.";
const confirmSubmitQuestion = "Are you sure you wish to submit?";

export const AppModal = memo(
  ({
    isOpen,
    loading,
    loadingClose,
    loadingContent,
    headerTitle,
    closeText = "Close",
    submitText = "Submit",
    errors,
    onClickSubmitBtn,
    onClose,
    header,
    actions,
    hideSubmit,
    hideClose,
    size = "xl",
    contentMinW = "60%",
    children,
    disableSubmit,
    contentMaxW,
    modalBodyProps,
    rightCornerBtnProps,
    showFooter = true,
    showRightConnerCloseButton = true,
    closeOnOverlayClick = false,
    modalContentProps,
    ...rest
  }: Props) => {
    const {
      onOpen: onOpenConfirmClosePopover,
      onClose: onCloseConfirmClosePopover,
      isOpen: isOpenConfirmClosePopover,
    } = useDisclosure();

    const {
      onOpen: onOpenConfirmRightConnerClosePopover,
      onClose: onCloseConfirmRightConnerClosePopover,
      isOpen: isOpenConfirmRightConnerClosePopover,
    } = useDisclosure();

    const {
      onOpen: onOpenConfirmSubmitPopover,
      onClose: onCloseConfirmSubmitPopover,
      isOpen: isOpenConfirmSubmitPopover,
    } = useDisclosure();

    const onClickYesPopover = (e: React.FormEvent) => {
      if (onClickSubmitBtn) {
        onClickSubmitBtn(e);
      }
      onCloseConfirmSubmitPopover();
    };

    const renderHeader = () => {
      if (header) {
        return header;
      }
      if (header === null) {
        return null;
      }
      return <ModalHeader>{headerTitle}</ModalHeader>;
    };

    const renderSubmitButton = () => (
      <UiButton isLoading={loading} disabled={disableSubmit} onClick={onClickSubmitBtn}>
        {submitText}
      </UiButton>
    );
    // return (
    //   <>
    //     <UiPopover
    //       placement={'auto'}
    //       isOpen={isOpenConfirmSubmitPopover}
    //       onOpen={onOpenConfirmSubmitPopover}
    //       onClose={onCloseConfirmSubmitPopover}
    //     >
    //       {/* @ts-ignore */}
    //       <UiPopoverTrigger>
    //         <UiButton isLoading={loading} disabled={disableSubmit}>
    //           {submitText}
    //         </UiButton>
    //       </UiPopoverTrigger>
    //       <UiPopoverContent>
    //         <UiPopoverArrow />
    //         <UiPopoverHeader>{confirmSubmitQuestion}</UiPopoverHeader>
    //         <UiPopoverBody>
    //           <UiHStack justify="center">
    //             <UiButton bg="baseColor" onClick={onClickYesPopover}>
    //               Yes
    //             </UiButton>
    //             <UiButton onClick={onCloseConfirmSubmitPopover}>Cancel</UiButton>
    //           </UiHStack>
    //         </UiPopoverBody>
    //       </UiPopoverContent>
    //     </UiPopover>
    //   </>
    // );
    const renderRightCornerCloseButton = () => (
      <UiButton
        bg="white"
        onClick={onClose}
        position="absolute"
        top="5px"
        right="5px"
        _focus={{ boxShadow: "none" }}
        _hover={{ bg: "white" }}
        {...rightCornerBtnProps}
      >
        <UiIcon as={AiOutlineClose} />
      </UiButton>
      // <>
      //   {!!disableSubmit || !!hideSubmit ? (
      //     <UiButton bg="white" onClick={onClose} position="absolute" top="5px" right="5px">
      //       <UiIcon as={AiOutlineClose} />
      //     </UiButton>
      //   ) : (
      //     <UiPopover
      //       placement={'auto'}
      //       isOpen={isOpenConfirmRightConnerClosePopover}
      //       onOpen={onOpenConfirmRightConnerClosePopover}
      //       onClose={onCloseConfirmRightConnerClosePopover}
      //     >
      //       {/* @ts-ignore */}
      //       <UiPopoverTrigger>
      //         <UiButton bg="white" isLoading={loadingClose} position="absolute" top="5px" right="5px">
      //           <UiIcon as={AiOutlineClose} />
      //         </UiButton>
      //       </UiPopoverTrigger>
      //       <UiPopoverContent>
      //         <UiPopoverArrow />
      //         <UiPopoverHeader>{confirmCloseQuestion}</UiPopoverHeader>
      //         <UiPopoverBody>
      //           <UiHStack justify="center">
      //             <UiButton bg="baseColor" onClick={onClose}>
      //               Yes
      //             </UiButton>
      //             <UiButton onClick={onCloseConfirmRightConnerClosePopover}>Cancel</UiButton>
      //           </UiHStack>
      //         </UiPopoverBody>
      //       </UiPopoverContent>
      //     </UiPopover>
      //   )}
      // </>
    );

    const renderCloseButton = () => (
      <UiButton variant="outline" isLoading={loadingClose} onClick={onClose}>
        {closeText}
      </UiButton>
      // <>
      //   {!!disableSubmit || !!hideSubmit ? (
      //     <UiButton variant="outline" isLoading={loadingClose} onClick={onClose}>
      //       {closeText}
      //     </UiButton>
      //   ) : (
      //     <UiPopover
      //       placement={'auto'}
      //       isOpen={isOpenConfirmClosePopover}
      //       onOpen={onOpenConfirmClosePopover}
      //       onClose={onCloseConfirmClosePopover}
      //     >
      //       {/* @ts-ignore */}
      //       <UiPopoverTrigger>
      //         <UiButton variant="outline" isLoading={loadingClose}>
      //           {closeText}
      //         </UiButton>
      //       </UiPopoverTrigger>
      //       <UiPopoverContent>
      //         <UiPopoverArrow />
      //         <UiPopoverHeader>{confirmCloseQuestion}</UiPopoverHeader>
      //         <UiPopoverBody>
      //           <UiHStack justify="center">
      //             <UiButton bg="baseColor" onClick={onClose}>
      //               Yes
      //             </UiButton>
      //             <UiButton onClick={onCloseConfirmClosePopover}>Cancel</UiButton>
      //           </UiHStack>
      //         </UiPopoverBody>
      //       </UiPopoverContent>
      //     </UiPopover>
      //   )}
      // </>
    );

    const renderActions = () => {
      if (actions) {
        return actions;
      }
      if (actions === null) {
        return null;
      }
      return (
        <UiHStack>
          {!hideSubmit && renderSubmitButton()}
          {!hideClose && renderCloseButton()}
        </UiHStack>
      );
    };

    return (
      <>
        {/*
        If we use scrollBehavior="inside", please be aware that Dropdown options inside this modal will be clipped.
        A workaround is adding overflow="visible" to the ModalBody, but it will block scrolling the whole content
      */}
        <Modal
          onClose={onClose}
          size={size}
          isOpen={isOpen}
          scrollBehavior="outside"
          trapFocus
          closeOnEsc
          closeOnOverlayClick={closeOnOverlayClick}
          {...rest}
        >
          <ModalOverlay />
          <ModalContent {...modalContentProps} minW={contentMinW} maxW={contentMaxW} rounded="16px">
            {renderHeader()}
            {showRightConnerCloseButton && renderRightCornerCloseButton()}
            <ModalBody {...modalBodyProps}>
              <AppMessage type="error" body={errors} />
              <UiBox>{children}</UiBox>
            </ModalBody>
            {showFooter && <ModalFooter>{renderActions()}</ModalFooter>}
          </ModalContent>
        </Modal>
      </>
    );
  }
);
